import { currentBreakpoint } from '@otto-ec/global-resources/viewport';
import type { ViewportSize } from '@tilelist/application/ports/ViewportSize.ts';

export function createViewportSize(): ViewportSize {
    return {
        isCompact: () => {
            const breakpoint = currentBreakpoint.get();
            return breakpoint === 's' || breakpoint === 'm';
        },
    };
}
